import { Box, Button, PopoverRoot, PopoverTrigger, PopoverPopup } from '@ff-it/ui';
import { EditorValue, RichTextRenderer } from 'components/RichText';
import { ReactElement } from 'react';
import { popoverContainer } from './style.css';

export function ContentPopoverButton({ content }: { content: EditorValue }): ReactElement | null {
  if (content == null) {
    return null;
  }
  return (
    <PopoverRoot>
      <PopoverTrigger>
        <Button icon="align-left" variant="ghost" size="xs" />
      </PopoverTrigger>
      <PopoverPopup>
        <Box className={popoverContainer}>
          <RichTextRenderer value={content} />
        </Box>
      </PopoverPopup>
    </PopoverRoot>
  );
}
